import React, { useEffect } from "react";
import { CheckCircle } from "lucide-react";
import { setActionConsecutiveDays } from "../../../../redux/features/schedule/ScheduleSlice";
import { useAppDispatch } from "../../../../redux/store";

const SuccessStep = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setActionConsecutiveDays(1));
  }, []);

  return (
    <div className="mt-2 bg-white p-4 rounded shadow">
      <div className="flex items-center mb-3 text-green-600">
        <CheckCircle className="w-5 h-5 mr-2" />
        <p className="text-sm font-medium">Your shift request has been successfully submitted.</p>
      </div>

      <p className="text-sm font-semibold mb-1">Key Information</p>
      <p className="text-sm mb-2">
        The relevant team members have been notified about your request to have this shift covered.
      </p>

      <p className="text-sm font-semibold mb-1">Stay Updated on Your Request</p>
      <p className="text-sm mb-2">
        Your shift swap request has been successfully submitted. Based on your account's workflow setup, the
        request may require approval from one or more levels before it is processed. You will be notified as
        your request progresses.
      </p>

      <p className="text-xs text-gray-500">
        Please note that while we’ve taken steps to assist in finding coverage, there's no guarantee that
        another employee will take your shift or that management will approve your request. It's advisable
        to follow up and ensure your request is addressed.
      </p>
    </div>
  );
};

export default SuccessStep;
